<template>
  <div>
    <!-- BootstrapVue Done -->
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-info">
      <b-row>
        <b-col xl="3" md="6">
          <stats-card
            type="gradient-info"
            icon="ni ni-chart-bar-32"
            class="mb-4"
          >
            <h5 class="card-title text-uppercase text-muted mb-0">
              JUMLAH SURVEYOR
            </h5>
            <span class="h2 font-weight-bold mb-0">{{ tableData.length }}</span>
          </stats-card>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--7">
      <b-row class="justify-content-center">
        <b-col lg="12">
          <card header-classes="bg-transparent">
            <!--Tables-->
            <b-row class="mt-2">
              <b-col xl="12" class="mb-5 mb-xl-0">
                <b-card body-class="p-0" header-class="border-0">
                  <template v-slot:header>
                    <b-row align-v="center">
                      <b-col>
                        <h3 class="mb-0">Data Surveyor</h3>
                      </b-col>
                    </b-row>
                  </template>
                  <div class="padding">
                    <div v-show="loading">
                      <Loading />
                    </div>
                    <v-client-table
                      :data="tableData"
                      :columns="columns"
                      :options="options"
                    >
                    </v-client-table>
                  </div>
                </b-card>
              </b-col>
            </b-row>
            <!--End tables-->
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import BaseHeader from "@/components/admin/BaseHeader";
import DataService from "@/services/data.service";
import Loading from "@/components/Loading.vue";

export default {
  name: "Surveyors",
  components: {
    BaseHeader,
    Loading
  },
  data() {
    return {
      loading: false,
      faculties: {},
      study_programs: {},
      columns: [
        "id_surveyor",
        "username",
        "nama_lengkap",
        "nm_fakultas",
        "nm_program_studi",
        "tlpn_hp"
      ],
      tableData: [],
      options: {
        headings: {
          nama_lengkap: "Username  ",
          nama_lengkap: "Nama Lengkap  ",
          nm_fakultas: "fakultas  ",
          nm_program_studi: "Program Studi  ",
          tlpn_hp: "Telepon "
        },
        sortable: true,
        filterable: true,
        hiddenColumns: ["id_surveyor"],
        texts: {
          count:
            "Menampilkan {from} sampai {to} dari {count} data|{count} data|Satu data",
          first: "Pertama",
          last: "Terahkir",
          filter: false,
          filterPlaceholder: "Pencarian",
          limit: false,
          page: "Page:",
          noResults: "Data tidak ada",
          loading: "Loading...",
          defaultOption: "Select {column}",
          columns: "Columns"
        },
        sortIcon: {
          is: "fa fa-sort",
          base: "font-awesome",
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          align: "center"
        },
        pagination: {
          show: true,
          dropdown: false,
          chunk: 5,
          edge: false,
          align: "center",
          nav: "fixed"
        }
      }
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  mounted() {
    this.getSurveyors();
  },
  methods: {
    getSurveyors() {
      this.loading = true;
      DataService.getSurveyorsFakultas(this.currentUser.user.username).then(
        res => {
          this.tableData = res.data.surveyors;
          if (this.tableData) {
            this.loading = false;
            return;
          }
        }
      );
    }
  }
};
</script>
<style scoped>
.padding {
  padding: 20px !important;
}
</style>
